import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSEO } from "@/hooks/useSEO";
import { waGeneral } from "@/config/siteConfig";
import { useQuote } from "@/context/QuoteContext";

const NotFoundPage = () => {
  const { openQuote } = useQuote();
  useSEO({ title: "Page Not Found | Book Kashmir", description: "The page you are looking for could not be found.", path: "/404" });
  return (
    <main className="py-24 sm:py-32 text-center" data-testid="not-found-page">
      <div className="max-w-xl mx-auto px-4">
        <p className="font-serif text-7xl font-bold text-[#D99B26]">404</p>
        <h1 className="mt-4 font-serif text-2xl sm:text-3xl font-semibold text-[#0F2F24]">This path doesn't lead to the valley</h1>
        <p className="mt-3 text-base text-slate-600">The page you're looking for doesn't exist — but your Kashmir holiday is still very much on the map.</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Button asChild className="bg-[#0F2F24] text-white hover:bg-[#1a4232] rounded-full px-6">
            <Link to="/" data-testid="notfound-home-link">Back to Home</Link>
          </Button>
          <Button asChild variant="outline" className="rounded-full px-6 border-[#0F2F24]/30 text-[#0F2F24]">
            <Link to="/kashmir-tour-packages" data-testid="notfound-packages-link">View Packages</Link>
          </Button>
          <Button onClick={() => openQuote()} variant="ghost" className="rounded-full px-6 text-[#C28519]" data-testid="notfound-quote-button">
            <MessageCircle className="mr-2 h-4 w-4" /> Get a Quote
          </Button>
        </div>
      </div>
    </main>
  );
};

export default NotFoundPage;
